// Mock data for baby feet measurement app

export const mockUsers = [
  {
    id: '1',
    username: 'parent1',
    password: 'password123',
    email: 'parent1@example.com',
    name: 'Sarah Johnson'
  },
  {
    id: '2',
    username: 'demo',
    password: 'demo',
    email: 'demo@example.com',
    name: 'Demo User'
  }
];

export const mockChildren = [
  {
    id: '1',
    userId: '1',
    name: 'Emma',
    dateOfBirth: '2023-06-15',
    gender: 'female',
    avatarColor: '#FFB4D6'
  },
  {
    id: '2',
    userId: '1',
    name: 'Liam',
    dateOfBirth: '2024-03-20',
    gender: 'male',
    avatarColor: '#A8D5FF'
  }
];

export const mockMeasurements = [
  {
    id: '1',
    childId: '1',
    date: '2024-01-15',
    lengthCm: 12.5,
    widthCm: 5.8,
    method: 'manual',
    usSize: 4,
    euSize: 19,
    ukSize: 3,
    ageMonths: 7
  },
  {
    id: '2',
    childId: '1',
    date: '2024-04-20',
    lengthCm: 13.2,
    widthCm: 6.0,
    method: 'camera',
    usSize: 5,
    euSize: 20,
    ukSize: 4,
    ageMonths: 10
  },
  {
    id: '3',
    childId: '1',
    date: '2024-07-10',
    lengthCm: 13.8,
    widthCm: 6.2,
    method: 'manual',
    usSize: 5.5,
    euSize: 21,
    ukSize: 4.5,
    ageMonths: 13
  },
  {
    id: '4',
    childId: '2',
    date: '2024-06-15',
    lengthCm: 10.5,
    widthCm: 5.0,
    method: 'camera',
    usSize: 2,
    euSize: 17,
    ukSize: 1,
    ageMonths: 3
  }
];

// Size conversion data
export const sizeConversionTable = [
  { ageMonths: '0-3', lengthCm: '8-10', usSize: '0-1', euSize: '15-16', ukSize: '0-0.5' },
  { ageMonths: '3-6', lengthCm: '10-11.5', usSize: '1-2', euSize: '16-17', ukSize: '0.5-1' },
  { ageMonths: '6-9', lengthCm: '11.5-12.5', usSize: '2-3', euSize: '17-18', ukSize: '1-2' },
  { ageMonths: '9-12', lengthCm: '12.5-13.5', usSize: '3-4', euSize: '18-19', ukSize: '2-3' },
  { ageMonths: '12-15', lengthCm: '13.5-14.5', usSize: '4-5', euSize: '19-20', ukSize: '3-4' },
  { ageMonths: '15-18', lengthCm: '14.5-15.5', usSize: '5-6', euSize: '20-22', ukSize: '4-5' },
  { ageMonths: '18-21', lengthCm: '15.5-16.5', usSize: '6-7', euSize: '22-23', ukSize: '5-6' },
  { ageMonths: '21-24', lengthCm: '16.5-17.5', usSize: '7-8', euSize: '23-24', ukSize: '6-7' }
];

// Helper functions
export const calculateAge = (dateOfBirth) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  const ageInMonths = (today.getFullYear() - birthDate.getFullYear()) * 12 + (today.getMonth() - birthDate.getMonth());
  return ageInMonths;
};

export const convertLengthToSize = (lengthCm) => {
  if (lengthCm < 10) return { us: 0.5, eu: 15, uk: 0 };
  if (lengthCm < 11.5) return { us: 1.5, eu: 16, uk: 0.5 };
  if (lengthCm < 12.5) return { us: 2.5, eu: 17, uk: 1.5 };
  if (lengthCm < 13.5) return { us: 3.5, eu: 18, uk: 2.5 };
  if (lengthCm < 14.5) return { us: 4.5, eu: 19, uk: 3.5 };
  if (lengthCm < 15.5) return { us: 5.5, eu: 21, uk: 4.5 };
  if (lengthCm < 16.5) return { us: 6.5, eu: 22, uk: 5.5 };
  return { us: 7.5, eu: 24, uk: 6.5 };
};

export const getRecommendation = (ageMonths, lengthCm) => {
  const sizes = convertLengthToSize(lengthCm);
  const expectedRange = sizeConversionTable.find(range => {
    const [min, max] = range.ageMonths.split('-').map(Number);
    return ageMonths >= min && ageMonths <= max;
  });

  if (!expectedRange) {
    return {
      status: 'normal',
      message: 'Measurement recorded successfully.',
      recommendation: 'Keep tracking your baby\'s growth regularly.'
    };
  }

  const [minLength, maxLength] = expectedRange.lengthCm.split('-').map(Number);
  
  if (lengthCm < minLength - 0.5) {
    return {
      status: 'small',
      message: 'Feet appear smaller than average for age.',
      recommendation: 'This is normal variation. Monitor growth and consult pediatrician if concerned.'
    };
  } else if (lengthCm > maxLength + 0.5) {
    return {
      status: 'large',
      message: 'Feet appear larger than average for age.',
      recommendation: 'This is normal variation. Some babies have faster foot growth.'
    };
  }

  return {
    status: 'normal',
    message: 'Foot size is within normal range for age.',
    recommendation: 'Continue monitoring growth. Measure every 2-3 months.'
  };
};